module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content flex-col"
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_c('img', {
    staticClass: "label2",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/实物寄送流程.png'
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "add-btn",
    on: {
      "click": _vm.createSampleDeliverySheet
    }
  }, [_c('span', {
    staticClass: "add-tag"
  }, [_vm._v("寄送实物")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layer3 flex-col"
  }, [_c('span', {
    staticClass: "paragraph1"
  }, [_vm._v("\n            查看送样指南和信息表、收集样本\n            "), _c('br'), _vm._v("\n            并填写实物信息表\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "paragraph1",
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_vm._v("\n            寄送实物\n            "), _c('br'), _vm._v("\n            并上传实物信息表\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "paragraph1",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("\n            顺丰快捷下单\n            "), _c('br'), _vm._v("\n            货到付款\n            "), _c('br'), _vm._v("\n            填写快递单号\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67735b86","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Material/MaterialSendProcess.vue
// module id = 1665
// module chunks = 8